import { useParams } from "react-router-dom";

import { useSubProfile } from "./hooks";
import { SubProfile } from "./SubProfile";

export function SubProfilePage() {
  const { subId }: { subId: string } = useParams();
  const { subProfile, isPending } = useSubProfile(subId);

  if (!subProfile || isPending) return <div></div>;

  return (
    <div className="page">
      <SubProfile {...subProfile} />
    </div>
  );
}
